export const formatNumber = (
  value: number,
  {minimumFractionDigits = 0, maximumFractionDigits = 2} = {},
): string =>
  value?.toLocaleString('de-DE', {
    minimumFractionDigits,
    maximumFractionDigits,
  }) || ''
